import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class PackagingSearchService {
    private apiUrl: string = this.config.get('apiUrl') + 'PackaginInstruction';
    private adminApiUrl: string = this.config.get('apiUrl') + 'Admin';

    constructor(private config: AppConfig, private http: Http) { }

    listOfPi(partNumber: string,
        partName: string,
        isSupplierUSer: boolean,
        supplierNumber: string,
        extendedSupplierNumber: string,
        supplierName: string,
        statusListIds: string,
        issuerUserId: string,
        searchMHNO: string,
        createdDateFrom: string,
        createdDateTo: string,
        includeNullDates: boolean,
        unit: string,
        issuerUserName: string,
        excludeSupplier: boolean,
        includePI: boolean,
        typeFilter: number,
        region:number): Observable<IReturnObject> {

        const url = `${this.apiUrl}/ListOfPi/?partNumber=${partNumber}`
            + `&partName=` + partName
            + `&isSupplierUSer=` + isSupplierUSer
            + `&supplierNumber=` + supplierNumber
            + `&extendedSupplierNumber=` + extendedSupplierNumber
            + `&supplierName=` + supplierName
            + `&statusListId=` + statusListIds
            + `&issuerUserId=` + issuerUserId
            + `&searchMHNO=` + searchMHNO
            + `&createdDateFrom=` + createdDateFrom
            + `&createdDateTo=` + createdDateTo
            + `&inlcludeNullStartDateInResult=` + includeNullDates
            + `&unit=` + unit
            + `&issuerUserName=` + issuerUserName
            + `&excludeSupplier=` + excludeSupplier
            + `&includePI=` + includePI
            + `&typeFilter=` + typeFilter
            + `&region=` + region;

        return this.http.get(url)
            .map((response, Response) => <IReturnObject>response.json());
    }

    ListOfPiforExcel(partNumber: string,
        partName: string,
        isSupplierUSer: boolean,
        supplierNumber: string,
        extendedSupplierNumber: string,
        supplierName: string,
        statusListIds: string,
        issuerUserId: string,
        searchMHNO: string,
        createdDateFrom: string,
        createdDateTo: string,
        inlcludeNullStartDateInResult: boolean,
        sortByColumn: string,
        sortOrder: string,
        unit: string,
        issuerUserName: string,
        excludeSupplier: boolean,
        includePI: boolean,      
        region:number,
        typeFilter: number): Observable<IReturnObject> {

        const url = `${this.apiUrl}/ListOfPiforExcel/?partNumber=${partNumber}`
            + `&partName=` + partName
            + `&isSupplierUSer=` + isSupplierUSer
            + `&supplierNumber=` + supplierNumber
            + `&extendedSupplierNumber=` + extendedSupplierNumber
            + `&supplierName=` + supplierName
            + `&statusListId=` + statusListIds
            + `&issuerUserId=` + issuerUserId
            + `&searchMHNO=` + searchMHNO
            + `&createdDateFrom=` + createdDateFrom
            + `&createdDateTo=` + createdDateTo
            + `&inlcludeNullStartDateInResult=` + inlcludeNullStartDateInResult
            + `&sortByColumn=` + sortByColumn
            + `&sortOrder=` + sortOrder
            + `&unit=` + unit
            + `&issuerUserName=` + issuerUserName
            + `&excludeSupplier=` + excludeSupplier
            + `&includePI=` + includePI
            + `&region=` + region
            + `&typeFilter=` + typeFilter;

        return this.http.get(url)
            .map((response, Response) => <IReturnObject>response.json());
    }

    getStatuses(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetStatusesWithDefault`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    GetPartPruUpdates(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPartPruUpdates`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getSelectedPruChanges(pruId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPruUpdates/?pruId=${pruId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    GetPruList(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPruListforSearch`)
            .map((response: Response) => <IReturnObject>response.json());
    }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/packaging-instruction-search/packaging-instruction-search.service.ts